import { Directive, ElementRef, Renderer2, HostListener, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appOverflow]'
})
export class OverflowDirective implements AfterViewInit {
  @Output() overflow = new EventEmitter<boolean>();
  @Output() atStart = new EventEmitter<boolean>();
  @Output() atEnd = new EventEmitter<boolean>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.checkOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkOverflow();
  }

  @HostListener('scroll')
  onScroll() {
    this.checkOverflow();
  }

  public checkOverflow() {
    const nativeElement = this.el.nativeElement;
    const hasOverflow = nativeElement.scrollWidth > nativeElement.clientWidth;
    const atStart = nativeElement.scrollLeft <= 50; // Check if scroll is at start or within 50px offset
    const atEnd = nativeElement.scrollLeft + nativeElement.clientWidth + 50 >= nativeElement.scrollWidth; // Check if scroll is at end or within 50px offset

    this.overflow.emit(hasOverflow);
    this.atStart.emit(atStart);
    this.atEnd.emit(atEnd);
  }
}
